export const MAX_BUNDLE_PRODUCTS = 15;

/**
 * Products added at the same time. The cart takes one "write" at a time, so more
 * would mostly wait on each other.
 */
export const MAX_CONCURRENT_PRODUCT_ADDS = 3;
